import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useEmployersService } from '@restworld/data-services';
import { QUERY_KEYS } from '@restworld/utils-common';

function useEmployerCompanySearchMutation() {
  const queryClient = useQueryClient();
  const employersService = useEmployersService();

  const mutation = useMutation({
    mutationFn: (params: { searchText?: string; countryCode: string }) => employersService.searchCompanies(params),
    onSuccess: (data: AxiosResponse<CompanyInfo[]>) => {
      queryClient.setQueryData([QUERY_KEYS.EMPLOYERS.COMPANY_SEARCH], data);
    },
  });

  return mutation;
}
export default useEmployerCompanySearchMutation;

export interface CompanyInfo {
  id?: string;
  businessType: string;
  city: string;
  companyName: string;
  countryCode: string;
  fiscalCode: string;
  houseNumber: string;
  provinceCode: string;
  streetName: string;
  vatNumber: string;
  zipCode: string;
}

export function useEmployerCompanySearchMutationCacheData() {
  const queryClient = useQueryClient();

  const getCacheData = useCallback(() => {
    const cacheData: AxiosResponse<CompanyInfo[]> = queryClient.getQueryData([QUERY_KEYS.EMPLOYERS.COMPANY_SEARCH]);
    return cacheData?.data;
  }, [queryClient]);

  return { getCacheData };
}
